(() => {
  const initMulticolumnVideos = (section) => {
    if (!section || section.dataset.arzzVideoLazyInit === 'true') return;

    const containers = Array.from(section.querySelectorAll('[data-arzz-video-container]'));
    if (!containers.length) return;

    section.dataset.arzzVideoLazyInit = 'true';

    const isMobile = () => window.matchMedia('(max-width: 749px)').matches;

    const loadVideo = (video) => {
      if (!video || video.dataset.loaded === 'true') return;

      video.querySelectorAll('source[data-src]').forEach((source) => {
        source.src = source.dataset.src;
        source.removeAttribute('data-src');
      });

      video.load();
      video.dataset.loaded = 'true';
    };

    const playVideo = (video, container) => {
      if (!video) return;

      if (container.dataset.activeMedia !== video.dataset.media) {
        container.dataset.activeMedia = video.dataset.media;
        container.classList.remove('is-video-playing');
      }

      const showControls = () => {
        if (container.dataset.activeMedia === video.dataset.media) {
          container.classList.add('is-video-playing');
        }
      };

      loadVideo(video);
      video.addEventListener('playing', showControls, { once: true });

      const playPromise = video.play();

      if (playPromise !== undefined) {
        playPromise.then(showControls).catch(() => {});
      } else if (!video.paused) {
        showControls();
      }
    };

    const pauseVideo = (video, container) => {
      if (!video) return;

      video.pause();

      if (container && container.dataset.activeMedia === video.dataset.media) {
        container.classList.remove('is-video-playing');
      }
    };

    const getActiveVideo = (container) => {
      const media = isMobile() ? 'mobile' : 'desktop';
      return container.querySelector(`[data-arzz-lazy-video][data-media="${media}"]`);
    };

    const updateContainer = (container) => {
      const activeVideo = getActiveVideo(container);
      const isInViewport = container.dataset.inViewport === 'true';

      container.querySelectorAll('[data-arzz-lazy-video]').forEach((video) => {
        if (video === activeVideo && isInViewport) {
          playVideo(video, container);
        } else {
          pauseVideo(video, container);
        }
      });
    };

    if (!('IntersectionObserver' in window)) {
      containers.forEach((container) => {
        container.dataset.inViewport = 'true';
        updateContainer(container);
      });
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          entry.target.dataset.inViewport = entry.isIntersecting ? 'true' : 'false';
          updateContainer(entry.target);
        });
      },
      { rootMargin: '250px 0px', threshold: 0.1 }
    );

    containers.forEach((container) => observer.observe(container));

    window.addEventListener('resize', () => {
      containers.forEach(updateContainer);
    });
  };

  const initAllMulticolumnVideos = (root = document) => {
    root.querySelectorAll('.arzz-multicolumn').forEach(initMulticolumnVideos);
  };

  window.ArzzMulticolumnVideo = window.ArzzMulticolumnVideo || {};
  window.ArzzMulticolumnVideo.init = initMulticolumnVideos;
  window.ArzzMulticolumnVideo.initAll = initAllMulticolumnVideos;

  initAllMulticolumnVideos();

  if (window.ArzzMulticolumnVideo.eventsBound === true) return;

  window.ArzzMulticolumnVideo.eventsBound = true;

  document.addEventListener('shopify:section:load', (event) => {
    initAllMulticolumnVideos(event.target);
  });
})();
